import { createContext, type PropsWithChildren, useContext, useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ClientsPageStore } from 'pages/clients/store/clientsPageStore'

export const ClientsViewContext = createContext<ClientsPageStore | null>(null)

export const useClientsViewContext = () => {
  const context = useContext(ClientsViewContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ClientsViewContext')

  return context
}

export const ClientsViewProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new ClientsPageStore(entities))

  useEffect(() => {
    return () => store.dispose()
  }, [])

  return <ClientsViewContext.Provider value={store}>{children}</ClientsViewContext.Provider>
}
